
export default {
    name: 'tarif-observation',
    components: {},
    props: {
        assurance_id: Number,
        fields: Array,
        assurance_select: Object,
        editing_observation_tarif_data: Object
    },
    data() {
        return {
            is_printing: false,
            observation_is_loading: true,
            observation_is_empty: false,
            is_error_load: false,

			observation_filter: "",
			perPage: 20,
			print_per_page: -1,
			currentPage: 1,
        }
    },

    watch: {
        assurance_select() {
            const data = {
                assurance_id: this.assurance_select.compagnie_id,
                data_type: 'observation'
            }
            this.getListeObservation(data)
        },

        editing_observation_tarif_data() {
            this.saveTarifObservation()
        }
    },

    computed: {
        tarif_observations() {
            return this.$store.getters["tarif_observations"];
        },

        observation_length() {
            return this.tarif_observations.length;
        },
    },

    mounted() {
        const data = {
            assurance_id: 0,
            data_type: 'observation'
        }
        this.getListeObservation(data)
    },

    methods: {
        getListeObservation(data) {
            this.observation_is_loading = true

            this.$store.dispatch('getTarificationTypeAdmission', data).then(() => {
                if (this.tarif_observations.length > 0) {
                    this.observation_is_empty = false
                } else {
                    this.observation_is_empty = true
                }
                this.observation_is_loading = false
            }).catch(() => {
                this.observation_is_loading = false
                this.is_error_load = true
            })
        },

        edit(data, type_prestation) {
            const tarif_data = {
                data: data,
                type_prestation: type_prestation
            }
            this.$emit('emitTarifObservation', tarif_data)
        },

        saveTarifObservation() {
            
            this.editing_observation_tarif_data.type_prestation = 'observation'
            this.$store.dispatch("saveTarifTypeAdmission", this.editing_observation_tarif_data).then((response) => {
                if (response.success) {
                    const data = {
                        assurance_id: this.assurance_select.compagnie_id,
                        data_type: 'observation'
                    }
                    this.getListeObservation(data)

                    this.$emit('emitCloseTarifModal')
                } else {
                    if (response.code == 401) {
                        this.errorToast("Une erreur s'est produite ! Merci de réessayer plustard.")
                    } else if (response.code == 500) {
                        this.errorToast("Une erreur s'est produite !")
                    }
                }
                this.save_loading = false
                this.btn_disable = false
            })
        },

        printTarifObservation() {
            const data = {
                data_type: 'observation',
                prestations: this.tarif_observations
            }
            
            this.$emit('emitPrintTarif', data)
        }
    }
}
